import { faCloudUpload } from '@fortawesome/pro-solid-svg-icons'
import { Button } from '@/ui'

export const UploadDocumentButton = ({ onClick }: { onClick: () => void }) => (
  <Button iconLeft={faCloudUpload} onClick={onClick} className="w-full">
    Upload Documents
  </Button>
)
